import type { ReasonsJustificationApi } from './types'

export const toReasonsJustification = (reasonsJustificationApi: ReasonsJustificationApi) => {
  return {
    description: reasonsJustificationApi.DescricaoMotivoNegociacao,
    id: reasonsJustificationApi.CodigoMotivoNegociacao,
  }
}

export const toReasonsJustificationData = (response: ReasonsJustificationApi[]) => {
  return {
    data: response.map((reason) => toReasonsJustification(reason)),
  }
}
